import { Link } from '@mui/material'
import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

import { Icon } from '#/components/Icon'
import { usePages } from '#/store/services/Pages/usePages'

export const usePage = () => {
  const pages = usePages()
  const { pathname } = useLocation()

  return useMemo(() => {
    const page = pages.getCurrent({ path: pathname })
    return page?.enabled ? page : undefined
  }, [pages, pathname])
}

export const getLinksList = links => {
  return links
    ?.filter(link => link.url)
    .map(({ text, url }) => (
      <Link
        key={url}
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          '&:hover': {
            color: 'primary.dark',
          },
          'alignItems': 'center',
          'display': 'flex',
          'gap': 2,
          'ml': 1,
        }}
      >
        <Icon name="link" size={16} />
        {text}
      </Link>
    ))
}
